require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-glennsl-reasonable-atom-starter.json") })
        }
      }, "path---package-unpublished-glennsl-reasonable-atom-starter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-glennsl-reasonable-atom-starter!./.cache/json/package-unpublished-glennsl-reasonable-atom-starter.json
// module id = 943
// module chunks = 231608221292675